// * GET =====================================

export const FEED_GET_APPLICABLE_CHARTS = `/feed/applicable_charts`;

export const FEED_GET_OPERATOR_HINTS = `/feed/feed_operator_hints`;

export const FEED_GET_REMOVED_ITEMS = (feedId: string) =>
  `/feed/${feedId}/removed_items`;

export const FEED_GET_CATEGORIES = (feedId: string) =>
  `/feed/${feedId}/categories`;

export const FEED_GET_FILTERS_LIST = (objectId: string) =>
  `/feed/${objectId}/filters_list`;

/** Title lookup for a filter item the loaded filters do not contain. */
export const FEED_GET_RESOLVE_FILTER_ITEM = `/feed/resolve_filter_item`;

export const FEED_GET_ALGORITHMS = (feedId: string) =>
  `/feed/${feedId}/algorithms`;

export const FEED_GET_CONTEXTS = (feedId: string) => `/feed/${feedId}/contexts`;

// * PATCH ===================================

export const FEED_PATCH_PROCESS = `/feed/process`;

export const FEED_PATCH_ALGORITHM_PARAMS = (feedId: string) =>
  `/feed/${feedId}/algorithm_params`;

export const FEED_PATCH_POST_VIEW_MODE = (feedId: string) =>
  `/feed/${feedId}/post_view_mode`;

export const FEED_PATCH_VIEWS = (feedId: string) => `/feed/${feedId}/views`;

export const FEED_PATCH_REMOVED_ITEMS = (feedId: string) =>
  `/feed/${feedId}/removed_items`;

export const FEED_PATCH_FEED = (feedId: string) => `/feed/${feedId}`;

export const FEED_PATCH_CONTEXT_MENU_OPTIONS = (objectId: string) =>
  `/feed/${objectId}/context_menu_options`;

// * POST ====================================

export const FEED_POST_BUILD_SOLR_QUERY_FROM_FILTERS = `/feed/build_solr_query_from_filters`;

export const FEED_POST_COPY_FEED = `/feed/copy_feed`;

export const FEED_POST_REMOVE_SELECTED_ITEMS = `/feed/remove_selected_items`;

export const FEED_POST_VALIDATE_USER_QUERY = `/feed/validate_user_query`;

export const FEED_POST_ALERT = (feedId: string) => `/feed/${feedId}/alert`;

export const FEED_POST_EXPORT = (feedId: string) => `/feed/${feedId}/export`;

export const FEED_POST_LIVE_FEED_STATUS = (feedId: string) =>
  `/feed/${feedId}/live_feed_status`;

export const FEED_POST_RESULTS = (feedId: string) => `/feed/${feedId}/results`;

export const FEED_POST_FILTER = (feedId: string) => `/feed/${feedId}/filter`;

export const FEED_POST_LIVE_PREVIEW = `/feed/live_preview`;

// * DELETE ==================================

export const FEED_DELETE_REMOVED_ITEMS = (feedId: string) =>
  `/feed/${feedId}/removed_items`;

export const FEED_DELETE_ALGORITHM = (feedId: string) =>
  `/feed/${feedId}/algorithms`;

// * PUT =====================================

export const FEED_PUT_FEED = `/feed`;
